
//
// Volume Button

volumeButton = {};

volumeButton.create = function() {
	var button = new PIXI.Container();

	InputHelpers.addGenerics(button);
	button._flags.muted = false;

	button.canEnable = function() {
		return soundManager.soundAvailable();
	};

	button.showButton = function() {
		if (this.canShow()) {
			if (button._flags.muted) {
				this.button.buttonDisabled.tint = 0x999999;
				this.button.buttonEnabled.tint = 0x999999;

				this.button.buttonDisabled.visible = true;
				this.button.buttonEnabled.visible = false;
			} else {
				this.button.buttonDisabled.tint = 0xFFFFFF;
				this.button.buttonEnabled.tint = 0xFFFFFF;

				this.button.buttonDisabled.visible = false;
				this.button.buttonEnabled.visible = true;
			}

			this.button.visible = true;
		} else {
			this.hideButton();
		}
	};

	button.onPressedCallback = function() {
		messageBus.post("audio:stateChanged", {
			type: "audio:stateChanged",
			muted: !this._flags.muted
		});
	};
	
	button.onCurrentMuteState = function(state) {
		this._flags.muted = state.muted;
	};
	
	messageBus.subscribe("audio:currentMuteState", button.onCurrentMuteState.bind(button));

	return button;
};

volumeButton.initialise = function(json, object) {};
volumeButton.getFilesRequired = function() {
	return [];
};

resourceManager.registerObjectType("volumeButton", volumeButton.create, volumeButton.initialise, volumeButton.getFilesRequired);